// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { EmptyBasket3 } from '../../assets/img';
import { Target } from '../../client';
import theme from '../../styled-components/dark';
import { withOpacity } from '../../styled-components/dark/helpers';

const Wrapper = styled.div`
  width: 100%;

  ${() => {
    if (Target.__MOBILE__) {
      return css`
        height: auto;
      `;
    }
  }}
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 13em;
  background-image: url(${EmptyBasket3});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
`;

const LabelWrapper = styled.div`
  height: 100%;
  width: 100%;
  padding-bottom: 2.5em;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Label = styled.div`
  position: relative;
  color: ${theme.BasketEmptyView.Label.color};
  font-size: 1.4em;
  font-weight: bold;
  padding-bottom: 0.5em;
`;

const SubLabel = styled.div`
  color: ${withOpacity(theme.BasketEmptyView.SubLabel.color, 'ee')};
  text-align: start;
  line-height: 1.1em;
`;

const BasketEmptyView = ({ label, subLabel }) => {
  return (
    <Wrapper>
      <ImageContainer />
      <LabelWrapper>
        <Label $subLabel={subLabel}>{label}</Label>
        <SubLabel>{subLabel}</SubLabel>
      </LabelWrapper>
    </Wrapper>
  );
};

export default BasketEmptyView;
